import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthLoadingSkeleton } from "@/components/skeletons/PageSkeletons";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return <AuthLoadingSkeleton />;
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
